// src/components/Auth/JoinPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SimpleRegisterForm from './SimpleRegisterForm';
import styles from './Auth.module.css';

const JoinPage = ({ onOpenLogin }) => { // 1. Accept the prop here
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (user) {
      navigate('/'); // Or '/dashboard' based on your route config
    }
  }, [user, navigate]);

  const handleLoginClick = () => {
    // 2. Trigger the state sitting in App.js
    if (onOpenLogin) {
      onOpenLogin();
    } else {
      console.warn("onOpenLogin prop not found on JoinPage");
    }
  };

  const handleRegisterSuccess = () => {
    navigate('/');
  };

  return (
    <div className={styles.joinPage}>
      <div className={styles.joinContainer}>
        <SimpleRegisterForm 
          onSuccess={handleRegisterSuccess}
          onLoginClick={handleLoginClick}
        />
        <div className={styles.joinFooter}>
          <p>By joining, you agree to our Terms of Service and Privacy Policy</p>
        </div>
      </div>
    </div>
  );
};

export default JoinPage;